module.exports = __webpack_public_path__ + "img/ssclick-success.daaef029.png";